import { Typography } from "@material-ui/core";
import * as theme from "../theme";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { OrangeButton } from "../general/OrangeButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoading,
  sendForgotEmail,
  storeEmailId,
  getPasswordErr,
  getPasswordEmlSent

} from "../store/passwordManagement";
import { useEffect, useState } from "react";
import { toast, ToastContainer  } from "react-toastify";

const ForgotPassword = (props) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Required"),
  });
  const isloading = useSelector(getIsLoading);
  const formOptions = { resolver: yupResolver(validationSchema) };
  const isEmlSent = useSelector(getPasswordEmlSent)
  // get functions to build form with useForm() hook
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;
  const dispatch = useDispatch();
  const passwordError = useSelector(getPasswordErr)
  const [email, setEmail] = useState();

  function onSubmit(data) {
    dispatch(storeEmailId(data.email));
    setEmail(data.email)
    // history.push("/reset");
    dispatch(
      sendForgotEmail({
        emailid: data.email,
        frontEndOrigin: window.location.origin,
      })
    );
  }
  var toastId = null;
  useEffect(() => {
    if(passwordError && email && !isloading){
      toastId = toast.error(passwordError, {toastId: 'fail1',autoClose: 1000})
    }
  }, [passwordError, email ]);

  useEffect(() => {
    if(isEmlSent){
      toast.success("An Email link has been sent to reset your password", {toastId: 'success1',})
    }
  }, [isEmlSent])
  return (
    <div
      style={{
        height: "100%",
        paddingLeft: "1rem",
        backgroundColor: theme.COLORS.question_area_bg,
      }}
    >
      <Typography
        variant="h5"
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "5vmin",
          color: theme.COLORS.secondary_skyblue,
          paddingTop: "2rem",
        }}
      >
        Forgot Password
      </Typography>
      <Typography
        style={{
          fontSize: 15,
          fontFamily: "GibsonRegular",
        }}
      >
        Please enter you Email address to proceed further to change your
        password.
      </Typography>
      <form
        style={{ display: "flex", flexDirection: "column" }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div
          style={{
            width: "50%",
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            margin: "1rem 0",
          }}
        >
          <label>Your Email address:</label>
          <input
            name="email"
            type="text"
            {...register("email")}
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
          />
          <div className="invalid-feedback">{errors.email?.message}</div>
        </div>
        <OrangeButton
          disable={isloading}
          type="submit"
          width="50%"
          style={{ fontWeight: "700" }}
          fontSize="2.5vmin"
          text="Confirm and send Email"
        ></OrangeButton>
        {
          isloading && 
          <div
            style={{
              fontWeight: "bold",
              display: "inline-block",
              clipPath: "inset(0 3ch 0 0)",
              animation: "l 1s steps(4) infinite"
            }}
          >
            Please wait ...
          </div>
        }
      </form>
    </div>
  );
};
export default ForgotPassword;
